MOVE.MORTGAGE.VULOAD = (function (MORTGAGE) {
  var loadVideoLibrary = function () {
    MOVE.DOMHelper.loadAsyncLib('//content.jwplatform.com/libraries/Frev7kSL.js');
  };

  var init = function() {
    loadVideoLibrary();
  };

  MORTGAGE.VULOAD =
  {
    init: init
  };

  return MORTGAGE.VULOAD;
})(MOVE.MORTGAGE || {});

if (MOVE.DataStore.getData('controllerName') === 'veteran_loans') {
  MOVE.MORTGAGE.VULOAD.init();
}



// WEBPACK FOOTER //
// ./mortgage/vuload.js